import {cn} from 'utils/cn'

/**
 * Magic UI — Animated Shiny Text (tailwind-v3 branch), ported to JS.
 * https://magicui.design/docs/components/animated-shiny-text
 *
 * A pale glare pans across the glyphs. The text colour must be
 * translucent for the glare to show through; override `via-*` for the
 * glare colour and `text-*` for the base. Needs the `shiny-text`
 * keyframes in tailwind.config.js. Deviation from upstream: the
 * `mx-auto max-w-md` layout defaults are dropped so this can sit inline
 * in a sentence.
 */
export const AnimatedShinyText = ({
  children,
  className,
  shimmerWidth = 100,
  ...props
}) => (
  <span
    style={{'--shiny-width': `${shimmerWidth}px`}}
    className={cn(
      'text-neutral-600/70',
      // Shine effect
      'motion-safe:animate-shiny-text bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shiny-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite]',
      // Shine gradient
      'bg-gradient-to-r from-transparent via-black/80 via-50% to-transparent',
      className
    )}
    {...props}
  >
    {children}
  </span>
)

export default AnimatedShinyText
